import {
  putStoreDetails,
  uploadCertificateInS3
} from '@/api/apis';
import StoreDetailsInterface from '@/model/store.mjs';
import getAccessTokenIstance from '@/utils/authentication';
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { ProfileForm } from './profileform';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ProfileModalInterface } from '@/model/profile.mjs';
import { profileSchema } from '@/model/yupSchema.mjs';
import { getStoreData } from '@/redux/app-selectors';
import { useDispatch } from 'react-redux';
import { callToGetStoreData } from '@/redux/app-slice';

export const ProfileIntialValue = {
  contact_email: null,
  contact_phone: null,
  name: '',
  seller_email: null,
  status: null,
  store_id: '',
  website: null,
  store_lic_type: null,
  store_license_file_path: null,
  store_license_key: null,
  store_premise_city: null,
  store_premise_state: null,
  store_premise_street: null,
  store_premise_zip_code: null,
  store_contact_fax: null
};

const ProfileModal = ({ isOpen, onClose }: ProfileModalInterface) => {
  const [isEditEnabled, setIsEditEnabled] = useState<boolean>(false);
  const [callPostApi, setCallPostApi] = useState<boolean>(false);
  const [callGetApi, setCallGetApi] = useState<boolean>(false);
  const [callUploadApi, setCallUploadApi] = useState<boolean>(false);
  const [file, setFile] = useState<FileList | null>();
  const [profileData, setProfileData] =
    useState<StoreDetailsInterface>(ProfileIntialValue);
  const [editProfileData, setEditProfileData] =
    useState<StoreDetailsInterface>(ProfileIntialValue);
  const storeData = getStoreData();
  const dispatch = useDispatch();

  useEffect(() => {
    callStoreGetApi();
  }, []);

  const {
    handleSubmit,
    register,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(profileSchema),
    mode: 'onChange',
    values: {
      contact_phone: profileData.contact_phone || '',
      name: profileData.name || '',
      contact_email: profileData.contact_email || '',
      store_premise_city: profileData.store_premise_city || '',
      store_premise_state: profileData.store_premise_state || '',
      store_premise_street: profileData.store_premise_street || '',
      store_premise_zip_code: profileData.store_premise_zip_code || '',
      store_contact_fax: profileData.store_contact_fax,
      seller_email: profileData.seller_email || ''
    }
  });

  async function callStoreGetApi() {
    try {
      setCallGetApi(true);
      const data = storeData;
      const response = {
        access_credentials: data.access_credentials,
        contact_email: data.contact_email,
        contact_phone: data.contact_phone,
        name: data.name,
        seller_email: data.seller_email,
        status: data.status,
        store_id: data.store_id,
        subscription_end_date: data.subscription_end_date,
        subscription_start_date: data.subscription_start_date,
        website: data.website,
        store_lic_type: data.store_lic_type,
        store_license_file_path: data.store_license_file_path,
        store_license_key: data.store_license_key,
        store_premise_city: data.store_premise_city,
        store_premise_state: data.store_premise_state,
        store_premise_street: data.store_premise_street,
        store_premise_zip_code: data.store_premise_zip_code,
        store_contact_fax: data.store_contact_fax,
        dealer_id: data.dealer_id
      };
      setProfileData(response);
      setEditProfileData(response);
    } catch (e) {
      console.log(String(e));
    }
    setCallGetApi(false);
  }

  useEffect(() => {
    if (callPostApi) callStorePostApi();
  }, [callPostApi]);

  useEffect(() => {
    if (callUploadApi && file && file[0].name) uploadFile(file[0]);
  }, [callUploadApi]);

  async function callStorePostApi() {
    let data = editProfileData;
    if (file && file[0].name) {
      const storeId = await getStoreId();
      data = {
        ...data,
        store_license_file_path: `certificates/${storeId}/${file[0].name}`
      };
    }
    putStoreDetails(data)
      .then((res) => {
        if (res.status === 200) {
          setCallPostApi(false);
          dispatch(callToGetStoreData());
        };
      })
      .catch((e: any) => {
        console.log(String(e));
        setCallPostApi(false);
      });
  }

  async function getStoreId() {
    const accessTokenINstance = await getAccessTokenIstance();
    return accessTokenINstance.getStoreId();
  }

  async function uploadFile(files: any) {
    setCallPostApi(true);
    const storeId = (await getStoreId()) || '';
    uploadCertificateInS3(files, storeId)
      .then((res) => {
        setProfileData({
          ...profileData,
          store_license_file_path: `certificates/${storeId}/${files?.name}`
        });
        setEditProfileData({
          ...profileData,
          store_license_file_path: `certificates/${storeId}/${files?.name}`
        });
        setCallUploadApi(false);
      })
      .catch((e) => {
        setCallUploadApi(false);
        console.log('Upload Error: ', String(e));
      });
  }
  function saveHandler() {
    if (isEditEnabled) {
      if (JSON.stringify(profileData) !== JSON.stringify(editProfileData)) {
        setCallPostApi(true);
      } else setCallPostApi(false);
      if (file && file[0].name) {
        setCallUploadApi(true);
      } else setCallUploadApi(false);
      setIsEditEnabled(false);
    } else {
      setIsEditEnabled(true);
      setCallPostApi(false);
      setCallUploadApi(false);
    }
  }
  return (
    <>
      <Modal
        isOpen={isOpen}
        onClose={() => {
          onClose();
          setIsEditEnabled(false);
        }}
        isCentered
      >
        <ModalOverlay />
        <ModalContent minWidth={'60rem'}>
          <ModalHeader bg={"#0C1E46"} color={"#fff"} >Profile</ModalHeader>
          <ModalCloseButton color={"#fff"} />
          <form onSubmit={handleSubmit(saveHandler)}>
            <ModalBody>
              <ProfileForm
                isEditEnabled={isEditEnabled}
                profileData={editProfileData}
                setProfileData={setEditProfileData}
                setFile={setFile}
                file={file}
                register={register}
                errors={errors}
                callUploadApi={callUploadApi}
              />
            </ModalBody>
            <ModalFooter>
              {isEditEnabled && (
                <>
                  <Button
                    isLoading={callPostApi || callUploadApi || callGetApi}
                    colorScheme="blue"
                    mr={3}
                    type="submit"
                  >
                    Save
                  </Button>
                  <Button
                    variant="ghost"
                    onClick={() => {
                      setIsEditEnabled(false);
                      setEditProfileData(profileData);
                    }}
                  >
                    Discard
                  </Button>
                </>
              )}
              {!isEditEnabled && (
                <Button
                  isLoading={callPostApi || callGetApi}
                  colorScheme="blue"
                  mr={3}
                  type="button"
                  onClick={() => setIsEditEnabled(true)}
                >
                  Edit
                </Button>
              )}
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ProfileModal;
